import Box from '@mui/material/Box';
import { UndeadBlocksTabs } from './undead-blocks';
import { FantomSurvivorTabs } from './fantom-survivor';
import { ReactNode } from 'react';
import { MobileLegendsTabs } from './mobile-legends';
import { MetaOpsTabs } from './metaops';
import { BigTimeTabs } from './big-time';
import { EvIoTabs } from './ev.io';
import { MiniRoyaleNationsTabs } from './mini-royale-nation';
import { PlanetIXTabs } from './planet-ix';
import { EarthFromAnotherSunTabs } from './earth-from-another-sun';
import { ChronosTabs } from './chronos';
import { BR1InfiniteTabs } from './br1-infinite';
import { RainiTheLordsOfLightTabs } from './raini-lords-of-light';
import { CardsOfEthernityTabs } from './cards-of-ethernity';
import { TheBornlessTabs } from './the-bornless';
import { MokensLeagueTabs } from './mokens-league';
import { SplinterlandsTabs } from './splinterlands';
import { ChampionsAscensionTabs } from './champions-ascension';
import { TheForgeArenaTabs } from './the-forge-arena';
import { PlanetMojoTabs } from './planet-mojo';
import { ReignOfTerrorTabs } from './reign-of-terror';
import { ShrapnelTabs } from './shrapnel';
import { WAGMIDefenseTabs } from './wagmi-defence';
import { WorldWar0xTabs } from './world-war-0x';
import { DecentralGamesTabs } from './decentral-games';
import { BattleForGiostoneTabs } from './battle-for-giostone';
import { TimeBreachersTabs } from './time-breachers';
import { KittyKartTabs } from './kittykart';
import { UldorTabs } from './uldor';
import { MightyActionHeroesTabs } from './mighty-action-heroes';
import { PulsarTabs } from './pulsar';
import { SpiderTanksTabs } from './spider-tanks';
import { AxieInfinityOriginsTabs } from './axie-infinity-origins';
import { AcryptiaTabs } from './acryptia';
import { WarsakenTabs } from './warsaken';
import { DarkCountryTabs } from './dark-country';
import { CritterCraftTabs } from './crittercraft';
import { AvalonTabs } from './avalon';
import { BlockchainBrawlersTabs } from './blockchain-brawlers';
import { TheWakeRagnaroksLabyrinthTabs } from './the-wake-ragnaroks-labyrinth';
import { CyberTitansTabs } from './cybertitans';
import { CyBallTabs } from './cyball';
import { MagicCraftTabs } from './magiccraft';
import { ChesslersTabs } from './chesslers';
import { CitizenConflictTabs } from './citizen-conflict';
import { BushiTabs } from './bushi';
import { MirandusTabs } from './mirandus';
import { SuperiorTabs } from './superior';
import { RuneSeekerTabs } from './rune-seeker';
import { RageEffectTabs } from './rage-effect';
import { ChampionsArenaTabs } from './champions-arena';
import { EternalParadoxTabs } from './eternal-paradox';
import { KatanaInuTabs } from './katana-inu';
import { LastExpeditionTabs } from './last-expedition';
import { MechaWorldTabs } from './mecha-world';
import { StarfallArenaTabs } from './starfall-arena';
import { TollanWorldsTabs } from './tollan-worlds';
import { CSGOTabs } from './cs-go';
import { LeagueOfLegendsTabs } from './league-of-legends';
import { SocialGamesTabs } from './social-games';
import { GodsUnchainedTabs } from './gods-unchained';
import { ComethBattleTabs } from './cometh-battle';
import { FarcanaTabs } from './farcana';
import { MetalCoreTabs } from './metalcore';
import { WildcardAllianceTabs } from './wildcard-alliance';
type TabPanelProps = {
  children?: ReactNode;
  dir?: string;
  index: number;
  value: number;
};
const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
};

export {
  TabPanel,
  UndeadBlocksTabs,
  FantomSurvivorTabs,
  MobileLegendsTabs,
  MetaOpsTabs,
  BigTimeTabs,
  EvIoTabs,
  MiniRoyaleNationsTabs,
  PlanetIXTabs,
  EarthFromAnotherSunTabs,
  ChronosTabs,
  BR1InfiniteTabs,
  RainiTheLordsOfLightTabs,
  CardsOfEthernityTabs,
  TheBornlessTabs,
  MokensLeagueTabs,
  SplinterlandsTabs,
  TheForgeArenaTabs,
  ChampionsAscensionTabs,
  PlanetMojoTabs,
  ReignOfTerrorTabs,
  ShrapnelTabs,
  WAGMIDefenseTabs,
  WorldWar0xTabs,
  DecentralGamesTabs,
  BattleForGiostoneTabs,
  TimeBreachersTabs,
  KittyKartTabs,
  UldorTabs,
  PulsarTabs,
  MightyActionHeroesTabs,
  SpiderTanksTabs,
  AxieInfinityOriginsTabs,
  AcryptiaTabs,
  WarsakenTabs,
  DarkCountryTabs,
  CritterCraftTabs,
  AvalonTabs,
  BlockchainBrawlersTabs,
  TheWakeRagnaroksLabyrinthTabs,
  CyberTitansTabs,
  CyBallTabs,
  MagicCraftTabs,
  ChesslersTabs,
  CitizenConflictTabs,
  BushiTabs,
  MirandusTabs,
  SuperiorTabs,
  RuneSeekerTabs,
  ChampionsArenaTabs,
  EternalParadoxTabs,
  KatanaInuTabs,
  LastExpeditionTabs,
  MechaWorldTabs,
  RageEffectTabs,
  StarfallArenaTabs,
  TollanWorldsTabs,
  CSGOTabs,
  LeagueOfLegendsTabs,
  SocialGamesTabs,
  GodsUnchainedTabs,
  ComethBattleTabs,
  FarcanaTabs,
  MetalCoreTabs,
  WildcardAllianceTabs,
};
